var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-loaidng"},_vm._l((_vm.count),function(item){return _c('div',{key:item,staticClass:"g-loading-block",style:({ height: _vm.height + 'px' })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }